import ApplicationAdapter from "./application";

export default class ServerBackupAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    return `${this.apiBaseUri}/server/createmanualbackup?serverid=${snapshot.belongsTo("server").id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/server/deletemanualbackup?backupid=${id}`;
  }
}
